import React from "react";
import moment from "moment";
import { Small } from "@components/typography/Small";
import WeekRange, { WeekRangeProps, weekToDate } from "./WeekRange";

export type Props = {
  ranges: WeekRangeProps[];
  hasMore?: boolean;
  showWeekPrefix?: boolean;
  limitTo?: number;
  hasMoreStyle?: React.CSSProperties;
};

export function WeekRanges(props: Props) {
  const { hasMore, showWeekPrefix = true, ranges = [] } = props;
  let _hasMore = hasMore;

  const currentTime = moment.utc().startOf("isoWeek");

  let _ranges = ranges
    .map((x) => ({
      ...x,
      from: weekToDate(x.from),
      to: weekToDate(x.to)
    }))
    .filter((x) => currentTime.isBefore(x.to))
    .map((x) => ({
      ...x,
      from: currentTime.isAfter(x.from) ? currentTime.toDate() : x.from
    }));

  if (props.limitTo != null) {
    _ranges = _ranges.slice(0, props.limitTo);
    _hasMore = ranges.length > props.limitTo;
  }

  return (
    <>
      {_ranges.map((range, i) => (
        <WeekRange key={i} withTitle={false} showWeekPrefix={showWeekPrefix} {...range} />
      ))}
      {_hasMore && (
        <Small style={{ position: "relative", top: -4, ...props.hasMoreStyle }}>…</Small>
      )}
    </>
  );
}
